import { Observable, Subject } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable()
export class DialogRef {
  constructor(@Inject(DOCUMENT) private document: any) { }

  close(result?: any) {
    if (document.getElementsByClassName('kx-cstm-popup-overlay').length == 1) {
      this.document.body.classList.remove('modal-open');
    }
    this._afterClosed.next(result);
  }

  private readonly _afterClosed = new Subject<any>();
  afterClosed: Observable<any> = this._afterClosed.asObservable();
}

export enum DialogModalSize {
  Sm, Md, Lg, Xl, XXl
}
